const urls = {
  //#region 用户
  userLogout: '/api/light/user/logout',
  //#endregion

  //#region 上传
  uploadImgGetToken: '/api/light/superAdmin/upload/imgGetToken',
  uploadToCDN: 'https://upload-z1.qiniup.com',
  //#endregion  

}

export default urls
